import r from "../managers/braze-instance.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function openSession() {
  if (!r.rr()) return;
  var i = r.nn();
  if (!i) return;
  i.openSession();
  var t = et.Us.Rs,
    o = new et(t, E);
  o.jr(t.Fs.hr, function (r, n) {
    var e = n.lastClick,
      s = n.trackingString;
    E.info("Firing push click trigger from ".concat(s, " push click at ").concat(e));
    var c = i.kr(e, s),
      g = function g() {
        rt.o().ve(ot.vr, [s], c);
      };
    i.$r(g, g), o.be(t.Fs.hr, r);
  }), o.Ds(t.Fs.wr, function (r) {
    i.yr(r);
  });
}